import { forwardRef } from 'react';
import { Grid, GridProps } from '@mui/material';

/**
 * Standard grid item that fits grids with one item per line for mobile, and 2 per lines for above.
 */
export const FormGridItem = forwardRef<HTMLDivElement, GridProps>((props: GridProps, ref) => {
  return <Grid ref={ref} item xs={12} sm={6} {...props} />;
});
